module.exports = "/_next/static/images/80f255ad770bec92a17a9689215c8286-apple-pay-mini.png.webp";